module.exports = __webpack_public_path__ + "img/bottom_building_002.0fda1dc3.svg";